import ActivityDetail, { getServerSideProps as gSSP } from '../../components/pages/ActivityDetail';

export default ActivityDetail;

export const getServerSideProps = gSSP;
